export const roles = [
  { label: 'Διαχειριστής κεντρικού συστήματος', value: 'Admin' },
  { label: 'Διαχειριστής ΕΚΑΠΥ', value: 'EkapyAdmin' },
  { label: 'Διαχειριστής Νοσοκομείου', value: 'HospitalAdmin' },
  { label: 'Διαχειριστής Κλινικής', value: 'ClinicAdmin' },
  { label: 'Χρήστης Προβολή', value: 'ViewOnly' },
];
